import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import KitA from './kitA';
import KitB from './kitB';
import KitC from './kitC';
import TabListA from './tabListA';
import TabListB from './tabListB';
import ModalsH5 from './modals';
import Terms from './terms';
import TabListC from './tabListC';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { useGlobal } from '@/utils/useGlobal';
import { hideCountry } from '@/components/PowerKitPreSale';
import { READY_HOME_TAB_SITES } from '@/components/PowerKitPreSale/components/Product';

export default function Product({}) {
    const { useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [activeType, setActiveType] = useState('rv');
    const [activeModal, setActiveModal] = useState('');

    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    // 点击自动偏移
    const switchTabFn = (aType: string) => {
        setActiveType(aType);
        if (READY_HOME_TAB_SITES.includes(locale)) {
            const target = document.querySelector('.kitProduct-h5 .kit-tab-lists') as HTMLElement;
            target.style.transition = 'all .2s ease-in-out';
            switch (aType) {
                case 'rv':
                    return (target.style.left = '0');
                case 'grid':
                    return (target.style.left = `${-(4.8 - 3.75) / 2}rem`);
                case 'home':
                    return (target.style.left = `${-(4.8 - 3.75 + 0.2)}rem`);
            }
        }
    };

    useEffect(() => {
        const htmlEl = document.querySelector('html') as HTMLElement;
        if (htmlEl) {
            if (activeModal && !htmlEl.classList.contains('ef-has-modal-full-viewport')) {
                htmlEl.classList.add('ef-has-modal-full-viewport');
            }
            if (!activeModal && htmlEl.classList.contains('ef-has-modal-full-viewport')) {
                htmlEl.classList.remove('ef-has-modal-full-viewport');
            }
        }
    }, [activeModal]);

    // 触屏拖拽mobile
    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        if (READY_HOME_TAB_SITES.includes(locale)) {
            originX = parseFloat(e.currentTarget?.style.left) || 0;
            startX = e.targetTouches[0].clientX;
        }
    };
    const touchMove = (e: any) => {
        if (READY_HOME_TAB_SITES.includes(locale)) {
            const moveX = e.targetTouches[0].clientX;
            const endX = originX + moveX - startX;
            if (endX <= 0 && endX >= -e.currentTarget.offsetWidth + window.innerWidth - 20) {
                e.currentTarget.style.transition = 'none';
                e.currentTarget.style.left = `${endX}px`;
            }
        }
    };

    return (
        <div className={`${css.kitProductH5} kitProduct-h5`}>
            <KitA />
            <KitB />
            <KitC />
            {locale !== 'au' && (
                <div className="kit-tab-head">
                    <ul className="kit-tab-lists" onTouchMove={touchMove} onTouchStart={touchStart}>
                        <div className={`kit-tab-head-item ${activeType == 'rv' ? ' active' : ''}`} onClick={() => switchTabFn('rv')}>
                            <span className="kit-tab-head-item-ms left-item">{t('presale.product.kit_tab_item_1')}</span>
                        </div>
                        <div className={`kit-tab-head-item ${activeType == 'grid' ? ' active' : ''}`} onClick={() => switchTabFn('grid')}>
                            <span className="kit-tab-head-item-ms mid-item">{t('presale.product.kit_tab_item_2')}</span>
                        </div>
                        {READY_HOME_TAB_SITES.includes(locale) && (
                            <div className={`kit-tab-head-item ${activeType == 'home' ? ' active' : ''}`} onClick={() => switchTabFn('home')}>
                                <span className="kit-tab-head-item-ms right-item">{t('presale.product.kit_tab_item_3')}</span>
                            </div>
                        )}
                    </ul>
                </div>
            )}
            <div className="kit-tab-cont">
                {activeType == 'rv' && (
                    <div className={`kit-tab-cont-item ${activeType == 'rv' ? ' active' : ''}`}>
                        <TabListA callBack={setActiveModal} />
                    </div>
                )}
                {activeType == 'grid' && (
                    <div className={`kit-tab-cont-item ${activeType == 'grid' ? ' active' : ''}`}>
                        <TabListB callBack={setActiveModal} />
                    </div>
                )}
                {activeType == 'home' && READY_HOME_TAB_SITES.includes(locale) && (
                    <div className={`kit-tab-cont-item ${activeType == 'home' ? ' active' : ''}`}>
                        <TabListC callBack={setActiveModal} />
                    </div>
                )}
            </div>
            {(!hideCountry.includes(locale) || locale === 'cn') && (
                <div className="terms-box">
                    <Terms />
                </div>
            )}

            {activeModal && (
                <div className={`modal ${activeModal ? 'activeModal' : ''}`}>
                    <ModalsH5 active={activeModal} callBack={setActiveModal} />
                </div>
            )}
        </div>
    );
}
